import Component from '@glimmer/component';

export default class AppPageFeed extends Component {}
